export enum LinkRelation {
    STYLESHEET = "stylesheet",
    ICON = "icon",
    PRELOAD = "preload",
    CANONICAL = "canonical",
    PREV = "prev",
    NEXT = "next",
}
